function truncateText(text, maxLength) {
  if (!text) return null;
  if (text?.length <= maxLength) {
    return text;
  } else {
    return text?.slice(0, maxLength) + "...";
  }
}

export default truncateText;
